import {useEffect, useState} from 'react';
import {TCountdown} from '@dazn/lp-web/src/types/countDown.types';

const formatWithLeadingZero = (value: number): string => {
    return value.toString().padStart(2, '0');
};
export const useCountdown = (targetTime?: string): TCountdown => {
    const [countdown, setCountdown] = useState<TCountdown>({
        days: '00',
        hours: '00',
        minutes: '00',
        seconds: '00',
        isTimerEnded: true
    });

    useEffect(() => {
        if (!targetTime) return;

        const targetDate = new Date(targetTime).getTime();

        const calculateCountdown = () => {
            const currentTime = Date.now();
            const timeDifference = targetDate - currentTime;

            if (timeDifference <= 0) {
                setCountdown({
                    days: '00',
                    hours: '00',
                    minutes: '00',
                    seconds: '00',
                    isTimerEnded: true
                });
                return;
            }

            const seconds = Math.floor((timeDifference / 1000) % 60);
            const minutes = Math.floor((timeDifference / 1000 / 60) % 60);
            const hours = Math.floor((timeDifference / (1000 * 60 * 60)) % 24);
            const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));

            setCountdown({
                days: formatWithLeadingZero(days),
                hours: formatWithLeadingZero(hours),
                minutes: formatWithLeadingZero(minutes),
                seconds: formatWithLeadingZero(seconds),
                isTimerEnded: false
            });
        };

        const intervalId = setInterval(calculateCountdown, 100);
        return () => clearInterval(intervalId);
    }, [targetTime]);

    return countdown;
};
